import Xarrow from "react-xarrows";
import { usePosts } from "../../providers/Posts";
import { useCategories } from "../../providers/Categories";

const Arrows = () => {
  const { loadPosts, posts } = usePosts();
  const { activeCategory } = useCategories();

  return loadPosts ? (
    <></>
  ) : (
    <div>
      {posts.map((item) => {
        return item.categories.map((cat, index) => {
          return (
            <Xarrow
              key={index}
              zIndex={-1}
              start={`cat${cat}`}
              end={`${item.id}`}
              showHead={false}
              strokeWidth={1}
              color={
                activeCategory === cat
                  ? "var(--secondaryBgColor)"
                  : `var(--opacityGrey)`
              }
              curveness={0.5}
              endAnchor={"middle"}
              startAnchor={"middle"}
            />
          );
        });
      })}
    </div>
  );
};

export default Arrows;
